import MobileViewCompanyInfo from "../Components/MobileViewCompanyInfo";
import { MobileViewCompanyInfoPropsTypes } from "../MobileViewCompanyInfoPropsTypes";

export default function MobileViewCompanyInfoContainer({
  surveyAnswersInfo,
  handleNextPage,
}: MobileViewCompanyInfoPropsTypes) {
  return (
    <MobileViewCompanyInfo
      surveyAnswersInfo={surveyAnswersInfo}
      handleNextPage={handleNextPage}
    />
  );
}
